const Footer = () => (
  <footer className="py-12 border-t border-glass">
    <div className="container px-6">
      <div className="flex flex-col md:flex-row items-center justify-between gap-8">

        {/* Left */}
        <div className="text-center md:text-left">
          <img
            src="/sterklight_white.svg"
            alt="Sterklight Logo"
            className="h-7 w-auto object-contain mb-4 md:mb-3"
          />
          <p className="text-sm font-display text-foreground">
            Engineering Intelligence.
          </p>
        </div>

        {/* Center - Quick Links */}
        <div className="flex flex-wrap justify-center gap-6 text-sm font-body text-muted-foreground">
          <a href="#solutions" className="hover:text-primary transition-colors">
            Solutions
          </a>
          <a href="#engineering" className="hover:text-primary transition-colors">
            Engineering
          </a>
          <a href="#projects" className="hover:text-primary transition-colors">
            Projects
          </a>
          <a href="#company" className="hover:text-primary transition-colors">
            Company
          </a>
          <a href="#contact" className="hover:text-primary transition-colors">
            Contact
          </a>
        </div>

        {/* Right - Social */}
        <div className="flex gap-6 text-sm font-body text-muted-foreground">
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors"
          >
            LinkedIn
          </a>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors"
          >
            GitHub
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary transition-colors"
          >
            Twitter
          </a>
        </div>
      </div>

      {/* Bottom */}
      <div className="mt-10 text-center text-xs text-muted-foreground font-body">
        © {new Date().getFullYear()} Sterklight. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;